import React from 'react';
import Banner from '../components/Banner';
import FeaturesSection from '../components/FeaturesSection';
import CraftsmanshipSection  from '../components/CraftsmanshipSection ';
import CategorySection from '../components/CategorySection';
import SilverCollection from '../components/SilverCollection';
import ContactSection from '../components/ContactSection';
const Home = () => {
  return (
    <>
      <Banner />
      <FeaturesSection />
      <CraftsmanshipSection />
      <CategorySection />
      <SilverCollection />
      <ContactSection />
    </>
  );
};

export default Home;